import { tv } from "../../../variants/tv.js";
const trVariants = tv({
    base: 'bg-neutral-1',
    variants: {
        striped: {
            true: 'even:bg-neutral-3/30 hover:bg-neutral-4 hover:text-neutral-11 active:bg-primary-3'
        },
        sticky: {
            true: 'border-b-1 border-primary-5',
            false: ''
        },
        tableBordered: {
            true: '',
            false: ''
        },
        isHeaderRow: {
            true: '',
            false: ''
        },
        color: {
            none: '',
            success: 'bg-success-3 hover:bg-success-4 active:bg-primary-3',
            error: 'bg-error-3 hover:bg-error-4 active:bg-primary-3',
            neutral: 'bg-neutral-3/30 hover:bg-neutral-4 active:bg-primary-3',
            caution: 'bg-caution-3 hover:bg-caution-4 active:bg-primary-3'
        }
    },
    compoundVariants: [
        {
            striped: false,
            tableBordered: true,
            isHeaderRow: false,
            class: 'nth-last-1:*:border-b-0'
        },
        {
            striped: false,
            isHeaderRow: false,
            color: 'none',
            class: 'hover:bg-neutral-2 active:bg-primary-3'
        }
    ],
    defaultVariants: {
        tableBordered: false,
        sticky: false,
        striped: false,
        isHeaderRow: false,
        color: 'none',
        isGroupHeader: false
    }
});
export { trVariants };
